import { useEffect, useMemo, useState } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { UseFundOwnershipParams } from './types';
import { conditions, customValidations, parser, reverseParser, totalParser } from './utilities';

const useFundOwnership = (props: UseFundOwnershipParams) => {
  const {
    visibleColumns,
    setVisibleColumns,
    customConfig,
    tableData,
    tableTerms,
    columns,
    isDisabled,
    fieldAttributes,
    captableInfo,
    capTableVersionsByCompany,
  } = props;
  const [spreadsheet, setSpreadsheet] = useState<SpreadsheetConfig>();

  const { capTable } = tableData;

  const capTableCurrency = useMemo(() => capTable?.currency, [capTable]);
  const securities = useMemo(() => captableInfo?.securities ?? [], [captableInfo]);

  useEffect(() => {
    if (visibleColumns && tableData.capTable) {
      setSpreadsheet(
        new SpreadsheetConfig({
          columns: visibleColumns,
          setColumns: setVisibleColumns,
          parser,
          totalParser,
          rowConfig: customConfig,
          conditions,
          fieldAttributes,
          name: 'fundOwnership',
          tableData: {
            ...tableData,
            columns,
            capTableVersionsByCompany,
            capTable: {
              ...tableData.capTable,
              securities,
            },
            isDisabled,
          },
          reverseParser,
          customValidations,
          showTotalColumn: true,
          showToolbar: true,
          tableTerms,
          hasColTitle: true,
          currencyFormatter: true,
          allowReorderColumns: !isDisabled,
          allowCloneColumn: !isDisabled,
          allowDeleteColumn: !isDisabled,
          page: 'captable',
          disabled: isDisabled,
          currency: capTableCurrency,
          reverseParseAfterLoad: true,
        } as any)
      );
    }
  }, [
    capTableVersionsByCompany,
    visibleColumns,
    setVisibleColumns,
    securities,
    isDisabled,
    capTableCurrency,
    tableTerms,
    capTable,
    columns,
    customConfig,
    fieldAttributes,
    tableData,
  ]);

  return {
    spreadsheet,
  };
};

export default useFundOwnership;
